import { Moment } from "moment";
import { Context, Settings } from "../../SettingsProvider";

export type GeneratorParams = {
    // random number generator, return numbers [0, 1]
    random: () => number;
    // names of statuses
    statuses: string[];
    // indices of statuses which should be preselected
    initialSelectedStatuses?: Set<string>;
    // chance [0..1] of skipping status and moving to the next, per each status
    skipStatusChance: number[];
    // names of items
    names: string[];
    // creation times of each item
    creationTimes: Moment[];
    // multiplier for transition speeds - some items are just faster..
    itemSpeedFactor: number[];
    // minimum time item can spend in status
    minStatusT: number | number[];
    // variation of length of time item can spend in status
    statusDt: number | number[];
    movePastLastStatus?: boolean;
    // done status should be last or activity_logs transitions may be weird
    closedStatus?: string;
    chanceOfJumpingToClosedStatus?: number[];
    chanceOfStayingInStatus?: number[];
    // simulate Monday.com context, settings so that the app can be run standalone
    mondayContext: Context;
    mondaySettings: Partial<Settings>;
}

export const COLUMN_ID = "status";
export const COLUMN_TYPE = "status";

export const NUMBER_COLUMN_ID = "numbers8";

export { default as generateItems } from "./items";
export { default as generateColumns } from "./columns";
export { default as generateActivityLogs } from "./activityLogs";
